/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkLinkSerialnumberWithProjectResultDto } from '../models/work-link-serialnumber-with-project-result-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkSerialnumbers } from '../models/work-serialnumbers';
import { WorkSerialnumbersUnregistered } from '../models/work-serialnumbers-unregistered';

@Injectable({ providedIn: 'root' })
export class WorkSerialnumbersV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `serialnumbersV2ControllerFindAllPaginated()` */
  static readonly SerialnumbersV2ControllerFindAllPaginatedPath = '/v2/serialnumbers';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serialnumbersV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  serialnumbersV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>created</li>
     * <li>contact.lastName</li>
     * <li>item.name</li>
     * <li>project.numberQualified</li>
     * <li>number</li>
     * <li>pmpp</li></ul>
     */
      sortBy?: Array<'created:ASC' | 'created:DESC' | 'contact.lastName:ASC' | 'contact.lastName:DESC' | 'item.name:ASC' | 'item.name:DESC' | 'project.numberQualified:ASC' | 'project.numberQualified:DESC' | 'number:ASC' | 'number:DESC' | 'pmpp:ASC' | 'pmpp:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkSerialnumbers>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSerialnumbersV2Service.SerialnumbersV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.projectId', params['filter.projectId'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkSerialnumbers>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'projectId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serialnumbersV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serialnumbersV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>created</li>
     * <li>contact.lastName</li>
     * <li>item.name</li>
     * <li>project.numberQualified</li>
     * <li>number</li>
     * <li>pmpp</li></ul>
     */
      sortBy?: Array<'created:ASC' | 'created:DESC' | 'contact.lastName:ASC' | 'contact.lastName:DESC' | 'item.name:ASC' | 'item.name:DESC' | 'project.numberQualified:ASC' | 'project.numberQualified:DESC' | 'number:ASC' | 'number:DESC' | 'pmpp:ASC' | 'pmpp:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkSerialnumbers>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
}> {
    return this.serialnumbersV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkSerialnumbers>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkSerialnumbers>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'projectId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `serialnumbersV2ControllerGetSerialnumbersUnregisteredForProjectId()` */
  static readonly SerialnumbersV2ControllerGetSerialnumbersUnregisteredForProjectIdPath = '/v2/serialnumbers/SerialnumbersUnregistered/{projectId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serialnumbersV2ControllerGetSerialnumbersUnregisteredForProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  serialnumbersV2ControllerGetSerialnumbersUnregisteredForProjectId$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkSerialnumbersUnregistered>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSerialnumbersV2Service.SerialnumbersV2ControllerGetSerialnumbersUnregisteredForProjectIdPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkSerialnumbersUnregistered>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serialnumbersV2ControllerGetSerialnumbersUnregisteredForProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serialnumbersV2ControllerGetSerialnumbersUnregisteredForProjectId(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkSerialnumbersUnregistered>> {
    return this.serialnumbersV2ControllerGetSerialnumbersUnregisteredForProjectId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkSerialnumbersUnregistered>>): Array<WorkSerialnumbersUnregistered> => r.body)
    );
  }

  /** Path part for operation `serialnumbersV2ControllerLinkWithProject()` */
  static readonly SerialnumbersV2ControllerLinkWithProjectPath = '/v2/serialnumbers/linkWithProject/{projectId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serialnumbersV2ControllerLinkWithProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  serialnumbersV2ControllerLinkWithProject$Response(
    params: {
      projectId: number;
      serialnumbers: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkLinkSerialnumberWithProjectResultDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSerialnumbersV2Service.SerialnumbersV2ControllerLinkWithProjectPath, 'patch');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.query('serialnumbers', params.serialnumbers, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkLinkSerialnumberWithProjectResultDto>>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serialnumbersV2ControllerLinkWithProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serialnumbersV2ControllerLinkWithProject(
    params: {
      projectId: number;
      serialnumbers: Array<string>;
    },
    context?: HttpContext
  ): Observable<Array<WorkLinkSerialnumberWithProjectResultDto>> {
    return this.serialnumbersV2ControllerLinkWithProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkLinkSerialnumberWithProjectResultDto>>): Array<WorkLinkSerialnumberWithProjectResultDto> => r.body)
    );
  }

  /** Path part for operation `serialnumbersV2ControllerUnlinkFromProject()` */
  static readonly SerialnumbersV2ControllerUnlinkFromProjectPath = '/v2/serialnumbers/unlinkFromProject/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serialnumbersV2ControllerUnlinkFromProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  serialnumbersV2ControllerUnlinkFromProject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSerialnumbersV2Service.SerialnumbersV2ControllerUnlinkFromProjectPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serialnumbersV2ControllerUnlinkFromProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serialnumbersV2ControllerUnlinkFromProject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.serialnumbersV2ControllerUnlinkFromProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
